import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Shuffle, History } from 'lucide-react';
import { saveMockSession } from '../mock';

const Home = () => {
  const [setupNumber, setSetupNumber] = useState('');
  const navigate = useNavigate();

  const handleStart = () => {
    const num = parseInt(setupNumber);
    if (num > 0 && num <= 100) {
      // Create paired list
      const pairedList = [];
      for (let i = 1; i <= num; i++) {
        pairedList.push(i, i);
      }

      // Create new session
      const newSession = {
        id: Date.now().toString(),
        setupNumber: num,
        drawnNumbers: [],
        remainingNumbers: pairedList,
        createdAt: new Date().toISOString(),
        completed: false
      };

      saveMockSession(newSession);
      navigate(`/lottery/${newSession.id}`);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50 flex items-center justify-center p-4">
      <div className="w-full max-w-6xl">
        <div className="text-center mb-12">
          <h1 className="text-6xl font-bold mb-4 bg-gradient-to-r from-orange-600 via-pink-600 to-purple-600 bg-clip-text text-transparent">
            Undian Lot | PERLASI NTT
          </h1>
          <p className="text-xl text-gray-600">Sistem undian acak dengan nomor berpasangan</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <Card className="border-2 hover:shadow-xl transition-all duration-300">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-2xl">
                <Shuffle className="w-6 h-6 text-orange-600" />
                Mulai Undian Baru
              </CardTitle>
              <CardDescription>Masukkan angka untuk membuat daftar undian berpasangan</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="space-y-2">
                <label className="text-sm font-medium">Masukkan Angka (1-100)</label>
                <Input
                  type="number"
                  min="1"
                  max="100"
                  value={setupNumber}
                  onChange={(e) => setSetupNumber(e.target.value)}
                  placeholder="Contoh: 5"
                  className="text-lg h-12"
                />
              </div>

              {setupNumber && parseInt(setupNumber) > 0 && (
                <div className="p-4 bg-gradient-to-r from-orange-100 to-pink-100 rounded-lg animate-in fade-in duration-300">
                  <p className="text-sm font-medium mb-2">Daftar yang akan dibuat:</p>
                  <p className="text-xs text-gray-600">
                    [{Array.from({ length: parseInt(setupNumber) }, (_, i) => `${i + 1}, ${i + 1}`).join(', ')}]
                  </p>
                  <p className="text-xs text-gray-500 mt-2">Total: {parseInt(setupNumber) * 2} nomor</p>
                </div>
              )}

              <Button
                onClick={handleStart}
                disabled={!setupNumber || parseInt(setupNumber) <= 0 || parseInt(setupNumber) > 100}
                className="w-full h-12 text-lg bg-gradient-to-r from-orange-600 to-pink-600 hover:from-orange-700 hover:to-pink-700 transition-all duration-300"
              >
                Mulai Undian
              </Button>
            </CardContent>
          </Card>

          <Card className="border-2 hover:shadow-xl transition-all duration-300">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-2xl">
                <History className="w-6 h-6 text-purple-600" />
                Riwayat Sesi
              </CardTitle>
              <CardDescription>Lihat semua sesi undian yang telah dibuat</CardDescription>
            </CardHeader>
            <CardContent>
              <Button
                onClick={() => navigate('/sessions')}
                variant="outline"
                className="w-full h-12 text-lg border-2 hover:bg-gradient-to-r hover:from-purple-50 hover:to-pink-50 transition-all duration-300"
              >
                Lihat Semua Sesi
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Home;